import { some } from 'lodash';

type DataType = { [key: string]: any };

const anyFilterIsSet = <T extends DataType>(data: T, ignoredProperties: (keyof T)[]): boolean => {
  return some(
    Object.keys(data).filter((key) => !ignoredProperties.includes(key as keyof T)),
    (key: keyof T) => data[key] !== null
  );
};

const filterHasChanged = <T extends DataType>(current: Partial<T>, data: T): boolean => {
  return Object.keys(current).some((key) => current[key] !== data[key]);
};

export { anyFilterIsSet, filterHasChanged };
